import { StringFormat } from "@packages/common";
import type { FilterDTO, FilterItemDTO } from "../../search";

export abstract class CapitalizeFilterTransformer {
  static transform(filter: FilterDTO): FilterDTO {
    const transformedItems: FilterItemDTO[] = filter.items
      .map((item) => {
        const value = item.label?.toLocaleLowerCase() ?? "";
        return {
          ...item,
          label: StringFormat.capitalizeWords(value, { onlyFirstWord: true }),
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label));

    return {
      ...filter,
      items: transformedItems,
    };
  }
}
